const MessageQueue = () => {
    // a map between message type and list of messages where last element is the last message
    let messages = {}; 

    // a map between message type and list of subscribers (which are simply functions)
    let subscribers = {};

    const publish = (type, message) => {
        if (!messages[type]) {
            messages[type] = [];
        }
        messages[type].unshift(message);
        notify(type, message);
    };

    const notify = (type, message) => {
        if (subscribers[type]) {
            subscribers[type].forEach(
                fn => fn(message));
        }
    };

    const subscribe = (type, fn) => {
        if (!subscribers[type]) {
            subscribers[type] = [];
        }
        subscribers[type] = [fn, ... subscribers[type]];
        return () => unsubscribe(type,fn);
    };

    const unsubscribe = (type, fn) => {
        if (!subscribers[type]) {
            return;
        }
        subscribers[type] = subscribers[type].filter(
            f => f !== fn);
    };

    const read = (type) => {
        // return all messages of that type
        return messages[type] || [];
    };

    // empties a message type and returns all the messages
    const drain = (type) => {
        let drained = read(type);
        messages[type] = [];
        return drained;
    };

    const clearQueue = () => {
        messages = {};
    };

    return {notify, subscribe, publish, read, drain, clearQueue};
};

export const {notify, unsubscribe, subscribe, publish, read, drain, clearQueue} = MessageQueue();

export const latest = (type) => read(type)[0];

window.subs = subscribe;
